export enum SortType {
    DEFAULT = "default",
    CLOSEST_TO_SEARCH = "closest_to_search",
    PRICE_ASC = "price_asc",
    PRICE_DESC = "price_desc",
    DATE_ASC = "date_asc",
    DATE_DESC = "date_desc",
}
